import { ReactPlugin } from '@microsoft/applicationinsights-react-js';
import {
  ApplicationInsights,
  type BaseTelemetryPlugin,
} from '@microsoft/applicationinsights-web';
import { ClientConfig } from '@/client-config';

const appInsightsPlugin = new ReactPlugin();

const appInsightsEnabled =
  ClientConfig.applicationInsightsConnectionString.length > 0;

const appInsights = new ApplicationInsights({
  config: {
    connectionString: ClientConfig.applicationInsightsConnectionString,
    disableTelemetry: !appInsightsEnabled,
    enableAutoRouteTracking: true,
    enableUnhandledPromiseRejectionTracking: true,
    disablePageUnloadEvents: ['unload'],
    extensions: [appInsightsPlugin satisfies BaseTelemetryPlugin],
  },
});

if (appInsightsEnabled) {
  appInsights.loadAppInsights();
}

export { appInsights, appInsightsPlugin };
